var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingArrow2Left(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 26,
    viewBox: "0 0 15 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_215_29",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.92816e-05 13.0215L13.6131 26L14.8142 24.8548L2.3798 13L14.8142 1.14517L13.613 7.52438e-06L-1.22131e-05 12.9785L0.0225279 13L3.92816e-05 13.0215Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6131 26L12.9231 26.7238L13.6131 27.3816L14.3031 26.7238L13.6131 26ZM3.92816e-05 13.0215L-0.69 12.2977L-1.44915 13.0215L-0.689999 13.7452L3.92816e-05 13.0215ZM14.8142 24.8548L15.5043 25.5786L16.2634 24.8548L15.5043 24.1311L14.8142 24.8548ZM2.3798 13L1.68977 12.2762L0.930607 13L1.68977 13.7238L2.3798 13ZM14.8142 1.14517L15.5042 1.86895L16.2634 1.14517L15.5042 0.421398L14.8142 1.14517ZM13.613 7.52438e-06L14.3031 -0.723766L13.613 -1.38164L12.923 -0.723766L13.613 7.52438e-06ZM-1.22131e-05 12.9785L-0.69005 12.2548L-1.44921 12.9785L-0.690044 13.7023L-1.22131e-05 12.9785ZM0.0225279 13L0.712567 13.7238L1.47173 13L0.71256 12.2762L0.0225279 13ZM14.3031 25.2762L0.690077 12.2977L-0.689999 13.7452L12.9231 26.7238L14.3031 25.2762ZM14.1242 24.1311L12.9231 25.2762L14.3031 26.7238L15.5043 25.5786L14.1242 24.1311ZM1.68977 13.7238L14.1242 25.5786L15.5043 24.1311L3.06984 12.2762L1.68977 13.7238ZM14.1242 0.421398L1.68977 12.2762L3.06984 13.7238L15.5042 1.86895L14.1242 0.421398ZM12.923 0.723781L14.1242 1.86895L15.5042 0.421398L14.3031 -0.723766L12.923 0.723781ZM0.690025 13.7023L14.3031 0.723782L12.923 -0.723766L-0.69005 12.2548L0.690025 13.7023ZM0.71256 12.2762L0.69002 12.2548L-0.690044 13.7023L-0.667504 13.7238L0.71256 12.2762ZM0.690079 13.7452L0.712567 13.7238L-0.667512 12.2763L-0.69 12.2977L0.690079 13.7452Z",
    fill: "black",
    mask: "url(#path-1-inside-1_215_29)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingArrow2Left);
export default __webpack_public_path__ + "static/media/landingArrow2Left.54604b75c32e1bb486ee32286444785e.svg";
export { ForwardRef as ReactComponent };